import { SignInButton, SignUpButton, UserButton } from '@clerk/react'
import { Link, router, usePage } from '@inertiajs/react'
import { useEffect, useRef, type ReactNode } from 'react'

export default function AppLayout({ children }: { children: ReactNode }) {
  // The server decides who is signed in (auth.user); Clerk's components only
  // render the buttons.
  const { auth } = usePage().props
  const user = auth.user

  // After a sign-out, the pages kept in the browser history (encrypted by
  // Inertia) must not reappear with the Back button.
  const wasSignedIn = useRef(user !== null)
  useEffect(() => {
    if (wasSignedIn.current && user === null) router.clearHistory()
    wasSignedIn.current = user !== null
  }, [user])

  return (
    <div className="min-h-dvh bg-stone-50 text-stone-900">
      <header className="mx-auto flex max-w-5xl items-center justify-between px-4 py-5">
        <Link href="/" className="text-xl font-black tracking-tight">
          indeck
        </Link>
        <nav className="flex items-center gap-4 text-sm font-semibold">
          {user ? (
            <>
              <Link href="/dashboard" className="hover:underline">
                Tableau de bord
              </Link>
              <UserButton />
            </>
          ) : (
            <>
              <SignInButton>
                <button type="button" className="hover:underline">
                  Se connecter
                </button>
              </SignInButton>
              <SignUpButton>
                <button
                  type="button"
                  className="rounded-full bg-stone-900 px-4 py-2 text-stone-50 hover:bg-stone-700"
                >
                  Créer un compte
                </button>
              </SignUpButton>
            </>
          )}
        </nav>
      </header>
      <main className="mx-auto max-w-5xl px-4 pb-16">{children}</main>
    </div>
  )
}
